import type { RuntimeConfig } from './config';

/**
 * The boot-time config, set once before React mounts. A module holder rather
 * than a React context so non-component modules (the API client, the media
 * URL resolver) can read it without being handed props.
 */
let current: RuntimeConfig | null = null;

export function setRuntimeConfig(config: RuntimeConfig): void {
  current = config;
}

export function runtimeConfig(): RuntimeConfig {
  if (!current) throw new Error('runtime config read before boot');
  return current;
}

export function hasRuntimeConfig(): boolean {
  return current !== null;
}

/**
 * The dev-panel / cost-meter gate. OPT IN with ?debug=1.
 *
 * THIS COMPARISON WAS INVERTED UNTIL THE SITE WENT PUBLIC, and the comment
 * sitting here said so: "Flip the comparison before a paying parent ever sees
 * this — hard line 8 is that COGS is invisible to customers." The build existed
 * to validate the backend, so the instrument was on unless you asked for the
 * parent's view with ?debug=0.
 *
 * That stopped being the right default the moment this deployed to
 * showling-app.pages.dev. What was on screen at that URL, to anyone who opened
 * it: the per-session dollar cost of generation, the speculation toggles with
 * their prices ("gate on typing pause (~$0.0004)", "draft portraits on
 * gate-allow (~$0.20)"), the in-flight memo, and the raw runtime config. A
 * parent is buying a film for their child, not reading our margin.
 *
 * ?debug=1 still gets all of it back, which is what the canary and a developer
 * use. The difference is that it is now a thing you ask for.
 */
export const DEBUG = new URLSearchParams(window.location.search).get('debug') === '1';
